export interface IFiltersData {
  id: string;
  title: string;
  value: string;
}

export const filtersData: Array<IFiltersData> = [
  {id: '1', title: 'جدیدترین', value: 'lastest'},
  {id: '2', title: 'پربازدیدترین', value: 'most_viewed'},
  {id: '3', title: 'نزدیک ترین ', value: 'nearest'},
  {id: '4', title: 'بالاترین امتیاز', value: 'top_rank'},
];
export const multiSelectData: Array<IFiltersData> = [
  {id: '1', title: 'آگهی فروشگاه ها', value: 'has_store'},
  {
    id: '2',
    title: 'آگهی های دارای قیمت',
    value: 'has_price',
  },
];
